import { createAsyncThunk } from "@reduxjs/toolkit";
import giftService from "../../../api/services/gift";

export const getDashboardData = createAsyncThunk(
  "dashboard/getDashboardData",
  async () => {
    return await giftService.getDashboardData();
  }
);
